import JustLift from "./JustLift";

export default JustLift;
